<template>
    <h3 class="header">{{label}}</h3>
</template>

<script>
export default {
    props: {
        label: String,
    },
    name: 'HeaderMain',
}
</script>
<style>
.header{
    margin-top: 20px;
    /* margin-left: 20px; */
}
</style>
